(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // Akordeon — Kategoriler + Urun ürün detay. Aynı anda tek açık; +/× ikonu
  // CSS'te döner; açılış sonrası (diğerleri kapandıktan sonra) ilgili başlığa
  // scroll. Sayfa açılışında hem HTML'deki .is-open hem de URL hash desteklenir.
  DNB.Accordion = {
    init: function () {
      var roots = document.querySelectorAll("[data-accordion]");
      Array.prototype.forEach.call(roots, function (root) { bind(root); });
    }
  };

  function bind(root) {
    if (root.getAttribute("data-accordion-init") === "1") return;
    root.setAttribute("data-accordion-init", "1");

    var items = root.querySelectorAll("[data-accordion-item]");

    Array.prototype.forEach.call(items, function (item) {
      var head = item.querySelector("[data-accordion-head]");
      if (!head) return;
      head.addEventListener("click", function (e) {
        e.preventDefault();
        toggle(root, item, true);
      });
    });

    // URL ile eşleşen akordeonu aç (öncelik hash'te; yoksa HTML .is-open kalır).
    var hash = (window.location.hash || "").replace(/^#/, "");
    if (hash) {
      var target = root.querySelector('[data-accordion-id="' + cssEscape(hash) + '"]');
      if (target) toggle(root, target, false);
    }
  }

  function toggle(root, item, scroll) {
    var wasOpen = item.classList.contains("is-open");
    var items = root.querySelectorAll("[data-accordion-item]");

    Array.prototype.forEach.call(items, function (it) { it.classList.remove("is-open"); });

    if (wasOpen) return; // aç→kapa

    item.classList.add("is-open");
    if (!scroll) return;

    var panel = item.querySelector("[data-accordion-panel]");
    if (panel) {
      var done = function (ev) {
        if (ev && ev.propertyName && ev.propertyName !== "grid-template-rows") return;
        panel.removeEventListener("transitionend", done);
        scrollToItem(item);
      };
      panel.addEventListener("transitionend", done);
      // transition tetiklenmezse güvenlik
      window.setTimeout(function () { done(); }, 500);
    } else {
      scrollToItem(item);
    }
  }

  var scrolled = false;
  function scrollToItem(item) {
    if (scrolled) return; // done + timeout iki kez çağırmasın
    scrolled = true;
    window.setTimeout(function () { scrolled = false; }, 100);

    var header = document.querySelector(".site-header");
    var offset = (header ? header.offsetHeight : 0) + 16;
    var rect = item.getBoundingClientRect();
    var top = (window.pageYOffset || document.documentElement.scrollTop) + rect.top - offset;

    if (DNB.ScrollService && DNB.ScrollService.lenis) {
      DNB.ScrollService.scrollTo(top);
    } else {
      window.scrollTo({ top: top, behavior: "smooth" });
    }
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return value.replace(/["\\]/g, "\\$&");
  }
})(window, document);
